
import storageFactory from './storageFactory';

export const localStore = storageFactory(() => localStorage);

const MAP_CURRENT_LOC = 'cbmap.geo';
const MAP_ACCOUNT_KEY = 'cbmap.acc';
const MAP_ACCOUNT_REGIONS = 'cbmap.regions';
const MAP_PREDICTION_KEY = 'cbmap.sug';
const MAP_GEOCODE_KEY = 'cbmap.gcode';
const MAP_USE_TYPE = 'cbmap.using';
const MAP_CACHE_REQ = 'cbmap.req';

// https://developer.mozilla.org/en-US/docs/Glossary/Base64

const encode64 = (d)=> {
  let code = btoa(unescape(encodeURIComponent(d)));
  code = code.replace(/(=)(=)?(=)?$/g, '');
  return code;
}

// NOTE: DON'T REMOVE
const decode64 = (d) =>{
  if (d.length % 4 !== 0){
    d += ('===').slice(0, 4 - (d.length % 4));
  }
  try{
    return decodeURIComponent(escape(atob(d)));
  }catch(err) {
    return null;
  }
}

export const hexToRGB = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

const getFontId = (fontName)=> {
  return fontName.replace(/\ /g, '+')
}

export const loadActiveFont = (fontName, options={})=> {
  const styleFontId = `cb-google-font-${getFontId(fontName)}`;
  const doc = options && options.document ? options.document : document
  let stylesheetNode = doc.getElementById(styleFontId);
  if(!stylesheetNode) {
    stylesheetNode = doc.createElement("style");
    stylesheetNode.id = styleFontId;
    // stylesheetNode.textContent
    doc.head.appendChild(stylesheetNode);
    stylesheetNode.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=${getFontId(fontName) || 'Roboto'}&display=swap');
    `
  }
}


export const addLinkStylesheet = (cssId, url, options={})=> {
  const doc = options.document ? options.document : document
  if(options && options.unique && options.className) {
    doc.querySelectorAll(`.${options.className}`).forEach((ll)=>(ll.remove()));
  }  
  if (!doc.getElementById(cssId)){
      const head  = doc.getElementsByTagName('head')[0];
      const link  = doc.createElement('link');
      link.id   = cssId;
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      link.media = 'all';
      if(options && options.className) link.className = options.className;
      head.appendChild(link);
  } 
}

// [{expiredAt, data, uid}]
const getListCachedData = (dataKey) => {
  let listCachedData = [];
  try {
    listCachedData = JSON.parse(localStore.getItem(dataKey))
  } catch {
    
  }
  if(!listCachedData) return []

  const timeNow = Date.now()
  return listCachedData.filter((sub)=>(sub.expiredAt && sub.expiredAt > timeNow));
}

const getListAccounts = ()=>{
  let listAccounts = [];
  try {
    listAccounts = JSON.parse(localStore.getItem(MAP_ACCOUNT_KEY))
  } catch {
    
  }
  if(!listAccounts) return []

  const timeNow = Date.now()
  return listAccounts.filter((sub)=>(sub.expiredAt && sub.expiredAt > timeNow));
}


// {id, data, expiredAt}
export const getAccount = (uid)=>{
  const accounts = getListAccounts()
  const cachedAccount = accounts.find((acc) => (acc.uid === uid))
  if (!cachedAccount) return null;

  try {
    const cachedData = JSON.parse(decode64(cachedAccount.data))
    return cachedData;
  } catch {
    
  }

  return null;
}


export const loadScript = (url, options={})=> {
  const doc = options.document ? options.document : document
  if(options && !options.optional && options.className && doc.querySelectorAll(`.${options.className}`).length > 0) {
    return false;
  }
  const script = doc.createElement( "script" );

  script.type = "text/javascript";
  if(script.readyState) {  // only required for IE <9
    script.onreadystatechange = function() {
      if ( script.readyState === "loaded" || script.readyState === "complete" ) {
        script.onreadystatechange = null;
        if(options.callback) options.callback();
      }
    };
  } else {  //Others
    script.onload = ()=> {
      if(options.callback) options.callback();
    };
  }
  if(options.className) {
    script.className = options.className;
  }
  script.src = url;
  script.defer = '';
  doc.getElementsByTagName( "head" )[0].appendChild( script );  
}


// {id, data, expiredAt}
export const storeAccount = (accountId, accountJSON, expiredInSeconds=60)=>{
  const listAccounts = getListAccounts();
  const otherAccounts = listAccounts.filter((fm)=>(fm.uid !== accountId));

  const timeNow = new Date();
  otherAccounts.push({
    data: encode64(JSON.stringify(accountJSON)),
    uid: accountId,
    expiredAt: timeNow.getTime() + expiredInSeconds * 1000
  })
  localStore.setItem(MAP_ACCOUNT_KEY, JSON.stringify(otherAccounts));
  return otherAccounts;
}

export const getRegions = (accountId) => {
  try {
    const cachedRegions =  getListCachedData(MAP_ACCOUNT_REGIONS)
    const regions = cachedRegions.find((acc) => acc.uid === accountId);
    return JSON.parse(decode64(regions.data));
  } catch (error) {
    return null;
  }
}

// {id, data, expiredAt}
export const storeRegions = (accountId, regionJSON, expiredInSeconds=60)=>{
  const cachedRegions =  getListCachedData(MAP_ACCOUNT_REGIONS)
  const otherRegions = cachedRegions.filter((fm)=>(fm.uid !== accountId));

  const timeNow = new Date();
  otherRegions.push({
    data: encode64(JSON.stringify(regionJSON)),
    uid: accountId,
    expiredAt: timeNow.getTime() + expiredInSeconds * 1000
  })
  localStore.setItem(MAP_ACCOUNT_REGIONS, JSON.stringify(otherRegions));
  return otherRegions;
}

export const getMapGeo = () => {
  let cachedGeo = {}; 
  try {
    cachedGeo = JSON.parse(localStore.getItem(MAP_CURRENT_LOC))
  } catch {
  }
  
  if(!cachedGeo || cachedGeo.expiredAt < Date.now()) return {}

  return cachedGeo
}

export const storeMapGeo = (data) => {
  localStore.setItem(MAP_CURRENT_LOC, JSON.stringify({
    ...data,
    expiredAt: Date.now() + 7 * 24 * 60 * 60 * 1000
  }))
}


const generateFingurePrint = ()=>{
  const navigator_info = window.navigator;
  const screen_info = window.screen;
  let uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += navigator_info.languages.join('');
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';
  return uid;  
}

export const generateBrowserId = (shopKey)=> {
  const timeNow = Date.now() - 2 * 1000;
  const expiredTime = timeNow + 5 * 60 * 1000 + Math.floor(Math.random() * 5000);
  const requestSecret = [
    encode64(timeNow),
    encode64(expiredTime),
    encode64(shopKey),
    encode64(generateFingurePrint()),
    encode64(window.location.hostname)
  ].join('-k-');
  const browserId = encode64(requestSecret);
  return browserId;
}

export const generateChecksum = (shopKey) => {
  const timeNow = Date.now() - 2 * 1000;
  const expiredTime = timeNow + 1 * 60 * 1000 + Math.floor(Math.random() * 5000);

  const requestSecret = [
    encode64(timeNow),
    encode64(shopKey),
    encode64(expiredTime),
  ].join('-k-');
  return encode64(requestSecret)
}


export const getParameters = ()=> {
  const result = {};
  window.location.search
      .substr(1)
      .split("&")
      .forEach((item)=>{
        const tmp = item.split("=");
        if(tmp[1]) {
          result[tmp[0]] = decodeURIComponent(tmp[1].replace(/\+/g, ' '));
        }
      });
  return result;
}

export const convertJsonToParams = (data) => {
  const parameters = []
  Object.keys(data).map((k) => {
    if (Array.isArray(data[k])) {
      data[k].map((e) => (
        parameters.push(encodeURIComponent(`${k}[]`) + '=' + encodeURIComponent(e || ''))
      ))
    } else if (data[k] && typeof(data[k]) === 'object') {
      // console.log(data[k])
      Object.keys(data[k]).map((key1) => (
        parameters.push(encodeURIComponent(`${k}[${key1}]`) + '=' + encodeURIComponent(data[k][key1] || ''))
      ))
    } else {
      parameters.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k] || ''))
    }
    return null;
})
  return parameters.join('&')
}

// ===========================================
// +++++++++++++++++++++++++++++++++++++++++++
// caching everything here
// +++++++++++++++++++++++++++++++++++++++++++
// ===========================================

const getCachedAllReqs = () => {
  try {
    const cachedData = localStore.getItem(MAP_CACHE_REQ) ? JSON.parse(localStore.getItem(MAP_CACHE_REQ)) : [];
    const validData = cachedData.filter(({expiredAt}) => (expiredAt > Date.now()));
    localStore.setItem(MAP_CACHE_REQ, JSON.stringify(validData));
    return validData;
  } catch {
    return [];
  }
}

const setCacheReq = (url, resp, expiredIn = 1 * 60 * 1000) => {
  const cachedData = getCachedAllReqs();
  const newData = cachedData.filter((item) => (item.url !== url));
  const newCachedData = [...newData, {
    url,
    expiredAt: Date.now() + (expiredIn || 60 * 1000),
    data: encode64(JSON.stringify(resp))
  }]
  localStore.setItem(MAP_CACHE_REQ, JSON.stringify(newCachedData));
}

export const fetchJSON = (url, expiredIn) => {
  const cachedData = getCachedAllReqs();
  const cachedReq = cachedData.find((item) => (item.url === url));
  return new Promise((resolve, reject) => {
    if (cachedReq) {
      try {
        const cachedResp = JSON.parse(decode64(cachedReq.data));
        return resolve(cachedResp);
      } catch {

      }
    } 
    fetch(url).then((resp) => resp.json()).then((resp) => {
      setCacheReq(url, resp, expiredIn);
      resolve(resp);
    }).catch(reject)
  })

}

// ===========================================
// cache predictions 
// get place prediction/autosuggestion
// ===========================================
const getCachedPredictions = () => {
  try {
    const cachedPredictions = JSON.parse(localStore.getItem(MAP_PREDICTION_KEY))
    return cachedPredictions.filter(({expiredAt}) => (!!expiredAt && expiredAt > Date.now()))
  } catch {
    return [];
  }
}

const storePredictions = (req, data) => {
  const reqkey = encode64(JSON.stringify(req));

  const cachedPredictions = getCachedPredictions().filter((prediction) => (prediction.reqkey !== reqkey))
  const newPredictions = [
    ...cachedPredictions,
    {
      reqkey,
      data: encode64(JSON.stringify(data)),
      expiredAt: Date.now() + 1 * 60 * 1000
    }
  ]
  localStore.setItem(MAP_PREDICTION_KEY, JSON.stringify(newPredictions))
}

const getPrediction = (req) => {
  const reqkey = encode64(JSON.stringify(req));
  const cachedPredictions = getCachedPredictions()
  const cachedPrediction = cachedPredictions.find((prediction) => (prediction.reqkey === reqkey))
  if(!cachedPrediction) return null;
  try {
    const data = JSON.parse(decode64(cachedPrediction.data))
    return data
  } catch {
    return null;
  }
}


export const requestPlacePredictions = (autocompleteService, req) => {
  return new Promise((resolve, reject) => {
    const cachedData = getPrediction(req);
    if(!!cachedData) return resolve(cachedData);
    if(!autocompleteService) return reject('You have not enabled autocomplete service');

    autocompleteService.getPlacePredictions(req, (e)=>{
      resolve(e)
      storePredictions(req, e)
      console.log('getPlacePredictions', e);
    })
  });
}


// ===========================================
// cache geocode 
// cache geocode by address/place_id
// ===========================================
export const getUsingMap = () => {
  const mapType = localStore.getItem(MAP_USE_TYPE)
  const expiredAt = mapType ? mapType.split('__')[1] : null;
  if (Date.now() < expiredAt) return mapType.split('__')[0];
  return null;
  // return localStore.getItem(MAP_USE_TYPE);
}

export const setUsingMap = (mapType) => {
  return localStore.setItem(MAP_USE_TYPE, `${mapType}__${Date.now() + 24 * 60 * 60 * 1000}`);
}
// ===========================================
// cache geocode 
// cache geocode by address/place_id
// ===========================================
const getCachedGeocodes = () => {
  try {
    const cachedGeocodes = JSON.parse(localStore.getItem(MAP_GEOCODE_KEY))
    return cachedGeocodes.filter(({expiredAt}) => (!!expiredAt && expiredAt > Date.now()))
  } catch {
    return [];
  }
}

const storeGeocode = (geo, data) => {
  const geokey = encode64(JSON.stringify(geo));
  const cachedGeocodes = getCachedGeocodes().filter((prediction) => (prediction.geokey !== geokey))
  const newGeocodes = [
    ...cachedGeocodes,
    {
      geokey,
      data: encode64(JSON.stringify(data)),
      expiredAt: Date.now() + 60 * 60 * 1000
    }
  ]
  localStore.setItem(MAP_GEOCODE_KEY, JSON.stringify(newGeocodes))
}

const getGeocode = (geo) => {
  const geokey = encode64(JSON.stringify(geo));

  const cachedGeocodes = getCachedGeocodes()
  const cachedGeocode = cachedGeocodes.find((prediction) => (prediction.geokey === geokey))
  if(!cachedGeocode) return null;
  try {
    const data = JSON.parse(decode64(cachedGeocode.data))
    return data
  } catch {
    return null;
  }
}

export const requestGeocode = (geocoder, geo) => {
  return new Promise((resolve, reject) => {
    const cachedData = getGeocode(geo);
    if(!!cachedData && cachedData.length > 0) {
      console.log('requestGeocode cached ', cachedData)
      return resolve(cachedData);
    }
    if(!geocoder) return reject("Geocoder is invalid");
    console.log('geocode', geocoder);
    geocoder.geocode(geo).then((resp) => {
      resolve(resp)
      storeGeocode(geo, resp)
    })  
  });  
}


// request current geolocation (browser)
// ===========================================
export const requestCurrentGeo = (geocoder) => {
  const currentGeo = getMapGeo()
  const promise = new Promise((resolve, reject) => {
    if(currentGeo && !!currentGeo.address && currentGeo.ip === 0) {
      return resolve(currentGeo);
    }
    
    if(!navigator.geolocation) return reject('Browser does not support geolocation');

    navigator.geolocation.getCurrentPosition((position) => {
      const {
        coords: {
          latitude,
          longitude
        } 
      } = position
      if(!geocoder) return resolve({
        lat: latitude,
        lng: longitude,
      });

      requestGeocode(geocoder, { location: {
        lat: latitude,
        lng: longitude,
      } }).then(({results}) => {
        const coordData = {
          lat: latitude,
          lng: longitude,
          address: results.length > 0 ? results[0].formatted_address : '',
          ip: 0,
          expiredAt: Date.now() + 7 * 24 * 60 * 60 * 1000
        }
        storeMapGeo(coordData);
        return resolve(coordData);
      })

    },
    (error) => {
      console.log('does not allow', error)
      return reject(error.message)
    }
    );
  })
  return promise;
}


export const syncLocationStates = (params) => {
  window.history.pushState(
    "",
    "",
    `?${convertJsonToParams({
      ...params,
    })}`
  );
}

// ==================================
// MAPs Utils
// ==================================
const parseStreet = (result, useShortName = true) => {
  console.log('parseStreet', result);
  const address_components = result.address_components;
  const streetNumber = address_components.find(({ types }) => types.includes("street_number"))

  const streetName = address_components.find(({ types }) => types.includes("route"))

  return [streetNumber, streetName].filter((obj) => (!!obj)).map((obj) => (useShortName ? obj.short_name : obj.long_name)).join(' ')
}

const parseStreet2 = (result, useShortName = true) => {
  const address_components = result.address_components;
  const subpremise = address_components.find(({ types }) => types.includes("subpremise"))
  if (!subpremise) return null;
  return useShortName ? subpremise.short_name : subpremise.long_name
}

const parseCity = (result, useShortName = true) => {
  const address_components = result.address_components;
  let city = address_components.find(({ types }) => types.includes("locality") && types.includes("political"))
  if (!city) {
    const province = address_components.find(({ types }) => types.includes("administrative_area_level_1") && types.includes("political"))
    if (province) {
      city = address_components.find(({ types }) => types.includes("administrative_area_level_2") && types.includes("political"))
    }
  }
  
  if (!city) return null;

  return useShortName ? city.long_name : city.long_name
}

const parseProvince = (result, useShortName = true) => {
  const address_components = result.address_components;
  let province = address_components.find(({ types }) => types.includes("administrative_area_level_1") && types.includes("political"))
  if (!province) {
    province = address_components.find(({ types }) => types.includes("administrative_area_level_2") && types.includes("political"))
  }

  if (!province) return null;

  return useShortName ? province.short_name : province.long_name
}

const parsePostalCode = (result, useShortName = true) => {
  const address_components = result.address_components;
  const postalCode = address_components.find(({ types }) => types.includes("postal_code"))
  if (!postalCode) return null;

  return useShortName ? postalCode.short_name : postalCode.long_name
}

const parseCountry = (result, useShortName = true) => {
  const address_components = result.address_components;
  const country = address_components.find(({ types }) => types.includes("country") && types.includes("political"))
  if (!country) return null;

  return useShortName ? country.short_name : country.long_name
}
const parseOSMComponents = (data) => {
  const rtData = {};
  console.log('parseOSMComponents', data);
  return rtData;
}

const parseMapboxComponents = (geocodingData) => {
  const rtData = {};

  // Iterate through the context array to extract address components
  geocodingData.context.forEach((contextItem) => {
    switch (contextItem.id.split('.')[0]) {
      case 'place':
        // Check if it's a city or town
        if (contextItem.text !== 'city' && contextItem.text !== 'town') {
          rtData.city = contextItem.text;
        }
        break;
      case 'region':
        // Check if it's a province or state
        if (contextItem.short_code) {
          rtData.province = contextItem.short_code;
        } else {
          rtData.province = contextItem.text;
        }
        break;
      case 'country':
        // Extract the country
        rtData.country = contextItem.text;
        break;
      case 'postcode':
        // Extract the postal code (if needed)
        if (contextItem.short_code) {
          rtData.postalCode = contextItem.short_code;
        } else {
          rtData.postalCode = contextItem.text;
        }
        break;
      default:
        // Extract additional address information
        rtData.street = contextItem.text;
        break;
    }
  });
  if(!rtData.street) rtData.street = geocodingData.text;
  return rtData;
};

const parseComponents = (result, useShortName = true) => {
  if(result.isOSM || (result.raw && result.raw.osm_id)) {
    return parseOSMComponents(result);
  }
  if(result.isMapbox || (result.bbox && result.properties?.mapbox_id)) {
    return parseMapboxComponents(result);
  }
  return ({
    street: parseStreet(result, useShortName),
    street2: parseStreet2(result, useShortName),
    city: parseCity(result, useShortName),
    province: parseProvince(result, useShortName),
    postalCode: parsePostalCode(result, useShortName),
    country: parseCountry(result, useShortName),    
  })
}

export const mapParser = {
  street: parseStreet,
  street2: parseStreet2,
  city: parseCity,
  province: parseProvince,
  postalCode: parsePostalCode,
  country: parseCountry,
  components: parseComponents
}